import React, { useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import IOnGetOrdersPickListDTO from "../../../models/DTO/IOnGetOrdersPickListDTO";
import moment from "moment-timezone";
import SupplierContext from "../../../contexts/SupplierContext";
import { DocLogo } from "../../shared/DocLogo/DocLogo";
import { WhiteLabelLogo } from "../../shared/WhiteLabelLogo/WhiteLabelLogo";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import "./PreformPickList.scss";
import * as _ from "lodash-es";
import UserService from "../../../services/UserService";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import UIService from "../../../services/UIService";
import { FormattedNumber } from "react-intl";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    data: IOnGetOrdersPickListDTO | undefined;
    /**
     * @deprecated
     */
    toggleMenu: () => void;
};

export const PreformPickList: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const [repeatArr, setRepeatArr] = useState<number[]>([]);

    useEffect(() => {
        const repeatCount = Array.from(Array(13), (_, x) => x);

        setRepeatArr(repeatCount);
    }, []);

    return (
        <div className={"PreformPickList"}>
            <div className={"d-print-none text-end mt-2"}>
                <OwPrintButton />
            </div>
            <div className={"pick-list-page-one"}>
                <div className={"d-flex justify-content-between"}>
                    <div>
                        {supplierModel.Doc_Logo ? <DocLogo maxWidth={"20rem"} height={"auto"} /> : <WhiteLabelLogo maxWidth={"20rem"} />}
                    </div>
                    <div>
                        <div className={"text-end"}>
                            <OwTitle title={"pick_list"} />
                        </div>
                        <div className={"d-flex text-center"}>
                            <div className={"border"}>
                                <div className={"border-bottom p-2"}>
                                    <OwLabel title={"date"} />
                                </div>
                                <div className={"p-2"}>{moment().format("MM/DD/YYYY")}</div>
                            </div>
                            <div className={"border border-left-0"}>
                                <div className={"border-bottom p-2"}>Order No.</div>
                                <div className={"p-2"}>{props.data?.orders[0].name}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"d-flex mt-3"}>
                    <div className={"w-50 border"}>
                        <div className={"border-bottom p-2"}>
                            <OwLabel title={"bill_to"} />
                        </div>
                        <div className={"p-2"}>
                            <AddressDisplay
                                showCompanyName={true}
                                showName={true}
                                address={props.data?.orders[0]?.Bill_To || supplierModel.Ship_To}
                            />
                        </div>
                    </div>

                    <div className={"w-50 border border-left-0"}>
                        <div className={"border-bottom p-2"}>
                            <OwLabel title={"ship_to"} />
                        </div>
                        <div className={"p-2"}>
                            <AddressDisplay
                                showCompanyName={true}
                                showName={true}
                                address={props.data?.orders[0]?.Ship_To || supplierModel.Ship_To}
                            />
                        </div>
                    </div>
                </div>

                <div className={"d-flex justify-content-between mt-3 text-center call-out-row"}>
                    <div className={"border me-3 flex-grow"}>
                        <div className={"border-bottom p-2"}>
                            <OwLabel title={"item_verification"} />
                        </div>
                        <div className={"p-2 data"}></div>
                    </div>

                    <div className={"border me-3 flex-grow"}>
                        <div className={"border-bottom p-2"}>
                            <OwLabel title={"ship_via"} />
                        </div>
                        <div className={"p-2 data"}>{props.data?.orders[0].qbo_ShipMethodRefValue || props.data?.orders[0].ship_via}</div>
                    </div>

                    <div className={"border me-3 flex-grow"}>
                        <div className={"border-bottom p-2"}>
                            <OwLabel title={"sales_rep"} />
                        </div>
                        <div className={"p-2 data"}>
                            {props.data?.orders[0].commissionUser?.name ||
                                props.data?.orders[0].sales_rep?.name ||
                                props.data?.orders[0].rep_group?.name ||
                                props.data?.orders[0].user?.name}
                        </div>
                    </div>

                    <div className={"border me-3 flex-grow"}>
                        <div className={"border-bottom p-2"}>
                            <OwLabel title={"customer_po"} />
                        </div>
                        <div className={"p-2 data"}>{props.data?.orders[0].po_no}</div>
                    </div>

                    <div className={"border flex-grow"}>
                        <div className={"border-bottom p-2"}>
                            <OwLabel title={"est_ship_date"} />
                        </div>
                        <div className={"p-2 data"}>
                            {_.isDate(props.data?.orders[0].est_ship_date)
                                ? ""
                                : UserService.parseDate(props.data?.orders[0].est_ship_date)}
                        </div>
                    </div>
                </div>

                <div className={"mt-3 d-flex flex-column item-section"}>
                    <div className={"d-flex border item-section-header"}>
                        <div className={"w-15"}>
                            <OwLabel title={"item_code"} />
                        </div>
                        <div className={"w-35"}>
                            <OwLabel title={"description"} />
                        </div>
                        <div className={"w-10"}>
                            <OwLabel title={"pack"} isUppercase={true} />
                        </div>
                        <div className={"w-10"}>
                            <OwLabel title={"each"} isUppercase={true} />
                        </div>
                        <div className={"w-20"}>
                            <OwLabel title={"batch_no"} />
                        </div>
                        <div className={"w-10"}>
                            <OwLabel title={"dom"} isUppercase={true} />
                        </div>
                    </div>
                    <div className={"item-section-body"}>
                        {props.data?.orderItems.map((orderItem) => {
                            const eachQty = Number(orderItem.Catalog_Item?.pack_qty || 0) * Number(orderItem.total_qty || 0);

                            return (
                                <div key={orderItem.guid} className={"d-flex item-section-body-item"}>
                                    <div className="w-15">{orderItem.Catalog_Item?.sku}</div>
                                    <div className="w-35">
                                        {orderItem.description || orderItem.Catalog_Item?.description}
                                        {orderItem.note ? (
                                            <div className={"mt-2 mb-3"}>
                                                <OwLabel title={"note"} className={"me-2"} postText={":"} />
                                                {orderItem.note}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="w-10 text-center">{orderItem.total_qty}</div>
                                    <div className="w-10 text-center">
                                        <FormattedNumber value={eachQty} />
                                    </div>
                                    <div className="w-20"></div>
                                    <div className="w-10"></div>
                                </div>
                            );
                        })}
                        <div className={"item-section-bottom"}>
                            <div className={"d-flex item-section-bottom-item"}>
                                <div className={"w-15"}></div>
                                <div className={"w-35"}></div>
                                <div className={"w-10"}></div>
                                <div className={"w-10"}></div>
                                <div className={"w-20"}></div>
                                <div className={"w-10"}></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"d-flex mt-3 partial-order-checkbox-container"}>
                    <div className={"partial-order-checkbox border me-3"}></div>
                    <OwLabel title={"partial_order"} />
                </div>

                <div className={"d-flex mt-3 bottom-footer-page-one"}>
                    <div className={"w-35"}>
                        <div className={"d-flex mt-3"}>
                            <OwLabel className={"no-wrap"} title={"date_of_shipment"} postText={":"} />
                            <div className={"border-bottom sign-line w-15r"}></div>
                        </div>
                        <div className={"d-flex"}>
                            <div className={"d-flex"}>
                                <OwLabel title={"carrier"} postText={":"} />
                                <div className={"border-bottom sign-line w-6r"}></div>
                            </div>
                            <div className={"d-flex"}>
                                <OwLabel title={"cost"} postText={":"} />
                                <div className={"border-bottom sign-line w-4r"}></div>
                            </div>
                        </div>
                        <div className={"d-flex"}>
                            <OwLabel title={"shipping_verification_initials"} postText={":"} />
                            <div className={"border-bottom sign-line"}></div>
                        </div>
                    </div>
                    <div className="w-20 align-items-center">
                        <div className={"d-flex mt-3"}>
                            <div className={"w-5r text-end me-1"}>Pallet #:</div>
                            <div className={"border-bottom sign-line w-1r"}></div>
                        </div>
                        <div className={"d-flex"}>
                            <div className={"w-5r text-end me-1"}>
                                <OwLabel title={"weight"} postText={":"} />
                            </div>
                            <div className={"border-bottom sign-line w-1r"}></div>
                        </div>
                        <div className={"d-flex"}>
                            <div className={"w-5r text-end me-1"}># of Boxes:</div>
                            <div className={"border-bottom sign-line w-1r"}></div>
                        </div>
                    </div>
                    <div className="w-45">
                        <div>Inspected by (please print initials and date):</div>
                        <div className={"d-flex"}>
                            <div className={"d-flex"}>
                                <OwLabel title={"production"} postText={":"} />
                                <div className={"border-bottom sign-line"}></div>
                            </div>
                            <div className={"d-flex"}>
                                ;<OwLabel className={"ms-1"} title={"date"} postText={":"} />
                                <div className={"border-bottom sign-line"}></div>
                            </div>
                        </div>
                        <div className={"d-flex"}>
                            <div className={"d-flex no-wrap"}>
                                Packing (packs boxes, etc):<div className={"border-bottom sign-line"}></div>
                            </div>
                            <div className={"d-flex"}>
                                ;<OwLabel className={"ms-1"} title={"date"} postText={":"} />
                                <div className={"border-bottom sign-line"}></div>
                            </div>
                        </div>
                        <div className={"d-flex"}>
                            <div className={"d-flex no-wrap"}>
                                Shipping (wraps/checks labels):<div className={"border-bottom sign-line"}></div>
                            </div>
                            <div className={"d-flex"}>
                                ;<OwLabel className={"ms-1"} title={"date"} postText={":"} />
                                <div className={"border-bottom sign-line"}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"pick-list-page-two border-bottom"}>
                <div className={"d-flex section-row-three border"}>
                    <div className={"ms-3"}></div>
                    <div className={"border-end"}>PALLET #</div>
                    <div className={"border-end"}>WEIGHT</div>
                    <div className={"border-end"}>BOX COUNT</div>
                    <div className={""}>ITEM DESC.</div>
                </div>

                {repeatArr.map((arr, index) => {
                    return (
                        <div key={index} className={"repeat-section border-start border-end pt-2"}>
                            <div className={"d-flex section-row-three-content bottom"}>
                                <div className={"ms-3"}>{index + 1}.</div>
                                <div>
                                    <div className={"border-bottom"}></div>
                                </div>
                                <div>
                                    <div className={"border-bottom"}></div>
                                </div>
                                <div>
                                    <div className={"border-bottom"}></div>
                                </div>
                                <div>
                                    <div className={"border-bottom"}></div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
